$(document).ready(function(){

	function openSubmitSection(){
		$('body').removeClass('mainMenu--open');
		setTimeout(function(){
			$('.section__submit .cta--submit').fadeOut();
			$('.section__submit .details').addClass('open');
		},200);
	}

	// -- Hamburger --
	$('.hamburger').on('click', function(){
		$('body').toggleClass('mainMenu--open');
		$(this).toggleClass('is-active');
	});

	// -- Close mobile menu when click
	$('.main__nav li a:not(.dropdown-toggle)').on('click', function(){
		$('body').removeClass('mainMenu--open');
		$('.hamburger').removeClass('is-active');
	});


	// -- menu submit (from homepage) --
	$('.header__submit .cta--submit').on('click', function(){
		openSubmitSection();
	});

	// -- menu submit (from anywhere) --
	var hash = window.location.hash;
	if (hash == '#section__submit') {
		$('html, body').animate({
			scrollTop: $(hash).offset().top - $('.header').outerHeight() - 30
		}, 'slow');
		openSubmitSection();
	}

});



$(document).on('scroll resize orientationchange', function(){
	// -- Header fixed --
	var scrollTop = $(this).scrollTop();
	var header = $('.header').outerHeight();
	if (scrollTop > header) {
		$('body').addClass('header--fixed');
	} else {
		$('body').removeClass('header--fixed');
	}

});